module.exports = __webpack_public_path__ + "static/img/006 4.6c316535.jpg";